import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SectionHeading } from '../../components/SectionHeading';

export function ProductsTeaser(): React.JSX.Element {
  return (
    <section id="products">
      <div className="container">
        <SectionHeading
          anim="zoom"
          title={
            <>
              Our <span className="si accent-text">flagship products</span>.
            </>
          }
          lede="Five products of our own — a modular cloud ERP, a 24/7 WhatsApp agent, a journal that organizes itself, a project workspace with an AI project manager built in, and an agency platform with an agent that watches your projects overnight. Built, sold, and supported by the same team that builds custom systems."
        />
        <div className="product-teaser-grid">
          <article className="product-card g-blue reveal" data-delay="1">
            <img
              className="product-mark"
              src="/assets/products/lumen.svg"
              alt=""
              loading="lazy"
            />
            <div className="product-kicker">Cloud ERP · SaaS</div>
            <h3 className="h3">Lumen ERP</h3>
            <p>
              Sales, purchases, inventory, payroll, CRM, and projects in one modular
              system. Most ERPs make you work their way — Lumen is built to be shaped
              to yours, module by module.
            </p>
            <div className="product-tags">
              <span className="tag">modular</span>
              <span className="tag">customizable</span>
              <span className="tag">multi-module</span>
            </div>
            <Link to="/lumen" className="product-link">
              Explore Lumen <ArrowRight size={16} />
            </Link>
          </article>

          <article className="product-card g-violet reveal" data-delay="2">
            <img
              className="product-mark"
              src="/assets/products/pulse.svg"
              alt=""
              loading="lazy"
            />
            <div className="product-kicker">WhatsApp automation · Agentic AI</div>
            <h3 className="h3">Pulse</h3>
            <p>
              An AI agent on your WhatsApp number, 24/7 — answering from your documents
              with RAG, calling your APIs, tagging contacts, and following up with leads
              on the official WhatsApp API.
            </p>
            <div className="product-tags">
              <span className="tag">24/7 agent</span>
              <span className="tag">RAG</span>
              <span className="tag">official API</span>
            </div>
            <Link to="/pulse" className="product-link">
              Explore Pulse <ArrowRight size={16} />
            </Link>
          </article>

          <article className="product-card g-ember reveal" data-delay="3">
            <img
              className="product-mark"
              src="/assets/products/mindflow.svg"
              alt=""
              loading="lazy"
            />
            <div className="product-kicker">AI journaling · Gemini</div>
            <h3 className="h3">MindFlow AI</h3>
            <p>
              Write one free-form entry. It comes back as a title, summary, sentiment,
              tags, goals, tasks, and memories — indexed, so you can ask questions about
              your own life in plain language.
            </p>
            <div className="product-tags">
              <span className="tag">zero filing</span>
              <span className="tag">auto-extraction</span>
              <span className="tag">ask anything</span>
            </div>
            <Link to="/mindflow" className="product-link">
              Explore MindFlow <ArrowRight size={16} />
            </Link>
          </article>

          <article className="product-card g-indigo reveal" data-delay="4">
            <img
              className="product-mark"
              src="/assets/products/projectflow.svg"
              alt=""
              loading="lazy"
            />
            <div className="product-kicker">Project management · Agentic AI</div>
            <h3 className="h3">ProjectFlow</h3>
            <p>
              Projects, tasks, approvals, time, invoices, and clients in one multi-tenant
              workspace — with Flo, an AI project manager that creates and assigns the
              work itself and waits for your approval before it acts.
            </p>
            <div className="product-tags">
              <span className="tag">AI project manager</span>
              <span className="tag">approvals</span>
              <span className="tag">web + Android</span>
            </div>
            <Link to="/projectflow" className="product-link">
              Explore ProjectFlow <ArrowRight size={16} />
            </Link>
          </article>

          <article className="product-card g-kinetix reveal" data-delay="1">
            <img
              className="product-mark"
              src="/assets/products/kinetix.svg"
              alt=""
              loading="lazy"
            />
            <div className="product-kicker">Agency project management · RAG + agents</div>
            <h3 className="h3">Kinetix</h3>
            <p>
              Projects, docs, proposals with eSign, time, invoices, and a client portal
              for creative agencies — with an assistant grounded in your own workspace
              and an agent that scans every project for risk overnight.
            </p>
            <div className="product-tags">
              <span className="tag">client portal</span>
              <span className="tag">RAG assistant</span>
              <span className="tag">autonomous agent</span>
            </div>
            <Link to="/kinetix" className="product-link">
              Explore Kinetix <ArrowRight size={16} />
            </Link>
          </article>
        </div>
      </div>
    </section>
  );
}
